export default {"src":"/_next/static/media/FIS.44ae55db.svg","height":18,"width":18};